// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26XtC","controls":"styles_controls__1uGZE","charLimit":"styles_charLimit__2e3v5","input":"styles_input__Z55JN","send":"styles_send__2mN-y"};